/**
 * SectionTitle — dashboard section heading that mirrors the RollM8s logotype.
 *
 * Rules:
 *  - Multi-word title: first word white, remaining word(s) in theme gradient.
 *  - Single-word title: split the word in half (left white, right gradient).
 *  - Uniform size + weight across the whole app so headings never drift.
 *
 * Gradient is theme-aware via the same CSS vars the logo uses
 * (--gradient-from / --gradient-to).
 */
const GRADIENT_STYLE = {
  background: 'linear-gradient(135deg, var(--gradient-from), var(--gradient-to))',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
};

export const SectionTitle = ({ children, className = '', ...rest }) => {
  const text = String(children || '');
  let leading;
  let trailing;

  if (text.includes(' ')) {
    const idx = text.indexOf(' ');
    leading = text.slice(0, idx);
    trailing = text.slice(idx); // keeps the space attached to the trailing half
  } else {
    const mid = Math.ceil(text.length / 2);
    leading = text.slice(0, mid);
    trailing = text.slice(mid);
  }

  return (
    <h2
      className={`text-2xl font-bold tracking-tight leading-tight ${className}`}
      {...rest}
    >
      <span className="text-white">{leading}</span>
      <span style={GRADIENT_STYLE}>{trailing}</span>
    </h2>
  );
};

export default SectionTitle;
